import {getDocument} from 'pdfjs-dist/legacy/build/pdf.mjs'
import type {PDFPageProxy} from 'pdfjs-dist'

export const getPDFPromise = (url: string, cmapDir: string) => {
  const cMapUrl = cmapDir[cmapDir.length - 1] === '/' ? cmapDir : `${cmapDir}/`

  return getDocument({
    url,
    cMapPacked: true,
    cMapUrl,
    // Disable range loading of PDF documents since raw doesn't seem to support it
    disableRange: true,
  }).promise
}

export const getCanvas = async (page: PDFPageProxy): Promise<[HTMLCanvasElement, null] | [null, Error]> => {
  // Scale viewport to page width
  const originalViewport = page.getViewport({scale: 1})
  // The default .com width is 900, lets use just over double that so we can
  // scale it down and have it look nice
  const scale = 2000 / originalViewport.width
  const viewport = page.getViewport({scale})

  // Construct canvas
  // If this canvas is created from an iframe's document, that iframe must be
  // visible in the DOM before creating canvas nodes. Attempting to write to
  // a canvas created from a document within a hidden iframe produces an NS_ERROR_FAILURE
  // see https://bugzilla.mozilla.org/show_bug.cgi?id=941146
  const canvas = document.createElement('canvas')
  canvas.classList.add('pdf-page')
  canvas.setAttribute('data-page', page._pageIndex)
  const canvasContext = canvas.getContext('2d')!

  // We need these to be set correctly so the pdf renders at the correct
  // size within the canvas
  canvas.height = viewport.height
  canvas.width = viewport.width
  try {
    await page.render({
      canvas,
      canvasContext,
      viewport,
    }).promise
    return [canvas, null]
  } catch (error) {
    return [null, error as Error]
  }
}
